/* eslint-disable max-len */
import { RouteConfig } from "vue-router";

import { metaRequireGuest } from "@/router/meta-constants";
import LoginPage from "@/views/login/index.vue";


const authenticateRoutes: Array<RouteConfig> = [
    {
        path: "/login",
        name: "Login",
        meta: {
            ...metaRequireGuest,
            isHideHeader: true
        },
        component: LoginPage,
    },
];

export default authenticateRoutes;
